if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.mobileView = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
      this.mediaContent = this.querySelector('.product-media-modal__content');
      this.mobileNav = this.querySelector('.hmg-mobile-media-nav');
      this.onLayoutChange = () => {
        const active = this.mediaContent.querySelector('[data-media-id].active');
        if (active) this.displayMedia(active);
      };

      if (this.mobileNav) {
        this.mobileNav.addEventListener('pointerup', (event) => event.stopPropagation());
        this.mobileNav.querySelector('.hmg-mobile-media-prev').addEventListener('click', () => this.moveMedia(-1));
        this.mobileNav.querySelector('.hmg-mobile-media-next').addEventListener('click', () => this.moveMedia(1));
      }

      this.addEventListener('keydown', (event) => {
        if (!this.mobileView.matches || !this.hasAttribute('open') || event.target.closest('deferred-media, product-model, input, textarea, select')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.moveMedia(event.key === 'ArrowRight' ? 1 : -1);
      });

      this.mediaContent.addEventListener('touchstart', (event) => {
        this.swipeStart = null;
        if (!this.mobileView.matches || event.touches.length !== 1 || !event.target.matches('img[data-media-id]') || (window.visualViewport && window.visualViewport.scale > 1.05)) return;
        this.swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });

      this.mediaContent.addEventListener('touchmove', (event) => {
        if (event.touches.length !== 1) this.swipeStart = null;
        if (!this.swipeStart) return;
        const dx = event.touches[0].clientX - this.swipeStart.x;
        const dy = event.touches[0].clientY - this.swipeStart.y;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2 && event.cancelable) event.preventDefault();
      }, { passive: false });

      this.mediaContent.addEventListener('touchend', (event) => {
        const start = this.swipeStart;
        this.swipeStart = null;
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.2) this.moveMedia(dx < 0 ? 1 : -1);
      }, { passive: true });

      this.mediaContent.addEventListener('touchcancel', () => { this.swipeStart = null; }, { passive: true });
    }

    hide() {
      this.swipeStart = null;
      this.mobileView.removeEventListener('change', this.onLayoutChange);
      super.hide();
    }

    show(opener) {
      if (this.mobileNav) this.mobileNav.hidden = !this.mobileView.matches || this.getMedia().length < 2;
      super.show(opener);
      this.showActiveMedia();
      this.mobileView.addEventListener('change', this.onLayoutChange);
    }

    getMedia() {
      return Array.from(this.mediaContent.children).filter((element) => element.hasAttribute('data-media-id'));
    }

    moveMedia(direction) {
      if (!this.mobileView.matches || !this.hasAttribute('open')) return;
      const media = this.getMedia();
      if (media.length < 2) return;
      const current = media.findIndex((element) => element.classList.contains('active'));
      window.pauseAllMedia();
      this.displayMedia(media[(current + direction + media.length) % media.length]);
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) this.displayMedia(activeMedia);
    }

    displayMedia(activeMedia) {
      const media = this.getMedia();
      media.forEach((element) => element.classList.toggle('active', element === activeMedia));
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      if (this.mobileView.matches) {
        this.mediaContent.scrollLeft = 0;
        this.mediaContent.scrollTop = 0;
      } else {
        activeMedia.scrollIntoView();
        this.mediaContent.scrollLeft = (activeMedia.width - this.mediaContent.clientWidth) / 2;
      }

      if (this.mobileNav) {
        this.mobileNav.hidden = !this.mobileView.matches || media.length < 2;
        this.mobileNav.querySelector('.hmg-mobile-media-count').textContent = `${media.indexOf(activeMedia) + 1} / ${media.length}`;
      }

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
